var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system"},[_c('img',{attrs:{"src":require("../assets/system.png")}}),_c('p',[_vm._v("系统维护中")]),_c('p',{staticStyle:{"font-size":"1rem"}},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }